// CheckboxSlider.js
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

const CheckboxSlider = ({ checked, onChange, onLabel, offLabel, labelStyle, ...rest }) => {
  const defaultLabelStyle = {
    fontSize: '14px',
    fontWeight: '500',
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
      <span style={{ ...defaultLabelStyle, color: !checked ? '#3498db' : '#888', ...labelStyle }}>
        {onLabel}
      </span>
      <Checkbox slider checked={checked} onChange={onChange} {...rest} />
      <span style={{ ...defaultLabelStyle,marginLeft: '10px', color: checked ? '#3498db' : '#888', ...labelStyle }}>
        {offLabel}
      </span>
    </div>
  );
};

CheckboxSlider.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  labelStyle: PropTypes.object,
};

CheckboxSlider.defaultProps = {
  checked: false,
  onChange: () => {},
  onLabel: 'On',
  offLabel: 'Off',
  labelStyle: {},
};

export default CheckboxSlider;
